import { InjectionToken, Type, NgModuleFactory } from '@angular/core';

export interface IThemeLoaderConfig {
  theme: string;
  load: () => Promise<NgModuleFactory<any> | Type<any> | any>;
}

export const THEME_LOADER = new InjectionToken<IThemeLoaderConfig[]>(
  'Theme Loader'
);
